import DetailListPage from "@/pages/DetailListPage";

export default function Solutions() {
  return (
    <DetailListPage
      collection="solutions"
      eyebrow="What We Do"
      title="Technology Solutions"
      subtitle="Integrated solutions across surveillance, command & control, coastal security, cybersecurity, data centres and smart governance — designed, deployed and maintained by Labpronics."
      heroImage="/generated/command.jpg"
    />
  );
}
